const name = "@achieve/cx-event-horizon";
const version = "0.16.0";
const description = "Analytics Library";
const author = "CX Tooling";
const license = "MIT";
const main = "dist/index.cjs";
const module = "dist/index.es.js";
const type = "module";
const types = "dist/index.d.ts";
const files = [
  "dist/**"
];
const scripts = {
  build: "vite build --config config/vite.config.ts",
  clean: "yarn clean:dist && yarn clean:modules && yarn clean:turbo",
  "clean:dist": "rimraf dist",
  "clean:modules": "rimraf node_modules",
  "clean:turbo": "rimraf .turbo",
  buildClean: "rm -rf dist",
  coverage: "rm -rf coverage && jest --coverage",
  lint: "eslint '**/**.js' --ignore-path .gitignore",
  "lint:fix": "eslint '**/**.js' --ignore-path .gitignore --fix",
  test: "vitest --config config/vitest.config.ts --watch=false",
  "test:watch": "vitest --config config/vitest.config.ts --watch",
  "vite-build": "vite build --config config/vite.config.ts",
  watch: "vite build --config config/vite.config.ts --watch"
};
const devDependencies = {
  "@achieve/eslint-config-node": "*",
  "@achieve/event-horizon-schemas": "*",
  "@achieve/version-checker": "*",
  "@types/node": "^18.0.0",
  "@typescript-eslint/eslint-plugin": "latest",
  "@typescript-eslint/parser": "^5.29.0",
  "eslint-plugin-jest": "^26.5.3",
  "ts-loader": "^9.3.1",
  "ts-node": "^10.8.1",
  typescript: "^5.0.4",
  vite: "^4.1.0",
  "vite-plugin-dts": "latest",
  vitest: "^0.29.2"
};
const dependencies = {
  analytics: "^0.8.14",
  "analytics-plugin-original-source": "^0.2.6",
  axios: "^1.8.3",
  cookie: "^0.7.0",
  "http-status-codes": "^2.3.0",
  "ua-parser-js": "^1.0.38",
  uuid: "^10.0.0",
  yup: "^1.4.0"
};
const peerDependencies = {};
const exports = {
  "./browser/*": "./dist/browser/*",
  "./browser": {
    "import": "./dist/browser.es.js",
    require: "./dist/browser.cjs",
    "default": "./dist/browser.es.js",
    types: "./dist/browser/index.d.ts"
  },
  "./server": "./dist/server.es.js",
  "./server/track-event": "./dist/track-event.es.js",
  "./server/validation/defaultSchema": {
    "import": "./dist/serverDefaultSchema.es.js",
    require: "./dist/serverDefaultSchema.cjs"
  },
  "./browser/plugins": "./dist/browserPlugins.es.js"
};
const jestSonar = {
  testEnvironment: "jsdom",
  reportFile: "sonar-reporter.xml",
  reportPath: "coverage"
};
const repository = "git@bitbucket.org:billsdotcom_bills/fdr-cx-event-horizon.git";
const pkg = {
  name,
  version,
  description,
  author,
  license,
  main,
  module,
  type,
  types,
  files,
  scripts,
  devDependencies,
  dependencies,
  peerDependencies,
  exports,
  jestSonar,
  repository
};
export {
  pkg as p
};
